/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { isEmptyObject } from "utils/ObjectUtils";

export const getActiveVerb = stores => stores.quickToolsStore.activeVerb;
export const getDisabledQuickToolsVerbs = stores => stores.quickToolsStore.disabledVerbs;
export const getVerbGroupState = stores => stores.quickToolsStore.verbGroupState;
export const getQuickToolsVerbs = stores => stores.quickToolsStore.quickToolsVerbs;
export const getFilteredVerbGroups = stores => stores.quickToolsStore.filteredQTGroups;
export const getComponentPropertyOfCurrentVerb = (stores, currentActiveVerb) =>
  stores.quickToolsStore.componentProperties.get(currentActiveVerb);
export const getCurrentVerbDisabledMsg = (stores, disabledStateMsg, currentActiveVerb) =>
  getComponentPropertyOfCurrentVerb(stores, currentActiveVerb).notificationMsg
    ? getComponentPropertyOfCurrentVerb(stores, currentActiveVerb).notificationMsg
    : disabledStateMsg;
export const getCurrentVerbOpts = (stores, currentActiveVerb) =>
  getComponentPropertyOfCurrentVerb(stores, currentActiveVerb).notificationOpts;
export const getCurrentVerbDisabledTooltipStr = (stores, currentActiveVerb) =>
  getComponentPropertyOfCurrentVerb(stores, currentActiveVerb).disabledTooltipStr;
export const getGroupIndexToShowFlyout = stores => stores.quickToolsStore.groupIndexToShowFlyout;
export const getVerbsAtIndex = (stores, groupIndex) => stores.quickToolsStore.verbGroupState[groupIndex].verbs;
export const getIsFocusOverQuickTools = stores => stores.quickToolsStore.isFocusOverQuickTools;
export const getIsClickedByMouse = stores => stores.quickToolsStore.isClickedByMouse;
export const getShowPrimaryPanel = stores => stores.quickToolsStore.showPrimaryPanel;
export const quickToolsVerbsPopulated = stores => !isEmptyObject(stores.quickToolsStore.quickToolsVerbs);
export const getShouldShowConditionalToolTip = stores => stores.quickToolsStore.shouldShowConditionalToolTip;
